import Form from './Form';
import Item from './Item';
import Validator from './Validator';

import FormComponent from './Form/Form.vue';
import FormItem from './Item/Item.vue';

import FormInput from './Input';
import FormCheckbox from './Checkbox';
import FormDate from './Date';
import FormDatePicker from './DatePicker';

export default {
  install(Vue) {
    Vue.component('BForm', FormComponent);
    Vue.component('BFormItem', FormItem);
    Vue.component('BFormInput', FormInput);
    Vue.component('BFormCheckbox', FormCheckbox);
    Vue.component('BFormDate', FormDate);
    Vue.component('BFormFormDatePicker', FormDatePicker);
  },
};

export {
  Form,
  Item,
  Validator,
  FormComponent,
  FormItem,
  FormInput,
  FormCheckbox,
  FormDate,
  FormDatePicker,
};
